var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "br-bt d-flex flex-column pb-24" }, [
    _c(
      "div",
      {
        staticClass: "content__topAmount align-self-end txt-gray",
        attrs: { "data-testid": "total-amount-text" }
      },
      [
        _vm._v(" Total Amount: "),
        this.country
          ? _c("span", [_vm._v(_vm._s(_vm.currencyCode))])
          : _vm._e(),
        _c("span", { staticClass: "total-po-amount" }, [
          _vm._v(" " + _vm._s(_vm.formattedTotalAmount))
        ])
      ]
    ),
    !_vm.isTotalAmountExceedMax
      ? _c(
          "label",
          {
            staticClass: "total__info mb-0",
            attrs: { "data-testid": "total-amount-note-text" }
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.getTextByCountry(
                    _vm.countryCode,
                    "component_totalAmount_label_text",
                    [_vm.currencyCode, _vm.formattedMaxTotalAmount]
                  )
                ) +
                " "
            )
          ]
        )
      : _c(
          "span",
          {
            staticClass: "total-amount-error-message content__feedback",
            attrs: { "data-testid": "total-amount-error" }
          },
          [
            _vm._v(
              " " +
                _vm._s(
                  _vm.errorFn(
                    _vm.formattedMaxTotalAmount,
                    _vm.formattedExceedAmount,
                    _vm.currencyCode
                  )
                ) +
                " "
            )
          ]
        )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }